module.exports = __webpack_public_path__ + "img/DE06544.c79faf08.png";